import { render, staticRenderFns } from "./CalcOrders.vue?vue&type=template&id=5b48c6f7&scoped=true"
import script from "./CalcOrders.vue?vue&type=script&lang=js"
export * from "./CalcOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48c6f7",
  null
  
)

export default component.exports